export default "__VITE_ASSET__CC$_oMax__"